module.exports = "https://coursera_assets.s3.amazonaws.com/images/b3048bea222d554c7bf6d12731982485.jpg";